import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { AppBasicEditorComponent } from '../../../../shared/components/app-basic-editor/app-basic-editor.component'
import { AppBasicSliderComponent } from '../../../../shared/components/app-basic-slider/app-basic-slider.component'
import { AppBasicCalendarComponent } from '../../../../shared/components/app-basic-calendar/app-basic-calendar.component'
import { AppBasicDropdownComponent } from '../../../../shared/components/app-basic-dropdown/app-basic-dropdown.component'

import { AppBasicInputComponent } from '../../../../shared/components/app-basic-input/app-basic-input.component'

@Component({
   selector: 'ep-proposal-detail-tab',
   templateUrl: './ep-proposal-detail-tab.component.html',
   standalone: true,
   imports: [AppBasicInputComponent, AppBasicDropdownComponent, AppBasicCalendarComponent, AppBasicSliderComponent, AppBasicEditorComponent, TranslateModule]
})
export class EpProposalDetailTabComponent {
   @Input() titleFC?: FormControl
   @Input() acronymFC?: FormControl
   @Input() foundingFC?: FormControl
   @Input() durationFC?: FormControl
   @Input() deadlineFC?: FormControl
   @Input() typeOfActionFC?: FormControl
   @Input() callOfTheProposalFC?: FormControl
   @Input() generalObjectivesFC?: FormControl
   @Input() typeOfActionArray?: { id: string; name: string }[]

   getErrorMessage(control?: FormControl): string {
      if (!control) return ''
      if (control.hasError('required')) return 'error_input_required'
      if (control.hasError('maxlength')) return 'error_input_maxLength'
      if (control.hasError('min')) return 'error_input_minNumber'
      if (control.hasError('max')) return 'error_input_maxNumber'
      return ''
   }
}
